module.exports = __webpack_public_path__ + "static/media/3DPPA22.cd7d8776.jpg";